import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    contentWrapper: {
        maxWidth: 800,
        margin: "0 auto",
        marginTop: 100,
    },
    step: {
        "& .Mui-active": {
            color: `${theme.palette.info.light} !important`,
            "& text": {
                fill: "white !important",
            },
        },
        "& .Mui-completed": {
            color: `${theme.palette.primary.dark} !important`,
            "& text": {
                fill: "white !important",
            },
        },
    },
}));
